import React, { Component, Fragment } from 'react'
import { Breadcrumb, Card, Row } from 'antd'
import List from './List'
import OrganisationsSelect from '../../../elements/Select/Organistaions'

class Accounts extends Component {
  render() {
    const { fetching, onChange, company } = this.props
    return (
      <Fragment>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Corporate</Breadcrumb.Item>
              <Breadcrumb.Item>Accounts</Breadcrumb.Item>
            </Breadcrumb>
            <h2>Chart of Accounts</h2>
            <p>View and list Chart of Accounts.</p>
          </Row>
        </Card>
        <Card>
          <OrganisationsSelect style={{ width: '33%' }} value={company} onChange={onChange} />
          <List {...this.props} loading={fetching} />
        </Card>
      </Fragment>
    )
  }
}

Accounts.propTypes = {}
Accounts.defaultProps = {
  list: {},
  value: {},
}

export default Accounts
